import { useDataContext } from "../../context/DataContext";

const GetHospitalData = (hospitalId: any, _extra?: any) => {
  const {
    metricasEspecialidades,
    especialidadesColorMap,
    tempoMedio7dias,
    // loading,
  } = useDataContext();

  let totalPacientesAguardando = 0;
  let totalGAESAbertas = 0;
  let totalDesistentes = 0;
  let totalRiscoLaranja = 0;
  let totalRiscoAmarelo = 0;
  let totalRiscoVerde = 0;
  let totalRiscoAzul = 0;
  const especialidadeData = [];

  for (let especialidade in metricasEspecialidades[hospitalId]) {
    if (!especialidadesColorMap.hasOwnProperty(especialidade)) continue;

    const dados = metricasEspecialidades[hospitalId][especialidade][0];
    especialidadeData.push({
      especialidade: especialidade,
      pacientes_aguardando_atendimento: dados.pacientes_aguardando_atendimento,
      gae_abertas: dados.gae_abertas,
      pacientes_desistentes: dados.pacientes_desistentes,
      risco_vermelho: dados.risco_vermelho,
      risco_laranja: dados.risco_laranja,
      risco_amarelo: dados.risco_amarelo,
      risco_verde: dados.risco_verde,
      risco_azul: dados.risco_azul,
      tempoMedio7dias:
        tempoMedio7dias[hospitalId][especialidade][0].tempo_atendimento,
    });

    for (const item of metricasEspecialidades[hospitalId][especialidade]) {
      totalPacientesAguardando += item.pacientes_aguardando_atendimento;
      totalGAESAbertas += item.gae_abertas;
      totalDesistentes += item.pacientes_desistentes;
      totalRiscoLaranja += item.risco_laranja;
      totalRiscoAmarelo += item.risco_amarelo;
      totalRiscoVerde += item.risco_verde;
      totalRiscoAzul += item.risco_azul;
    }
  }

  // if (loading) return <p>Loading...</p>;

  // ordenar pelo maior número de pacientes aguardando
  especialidadeData.sort(
    (a, b) =>
      b.pacientes_aguardando_atendimento - a.pacientes_aguardando_atendimento
  );

  return {
    Hospital: hospitalId,
    PacientesAguardando: totalPacientesAguardando,
    GAESAbertas: totalGAESAbertas,
    Desistentes: totalDesistentes,
    total_risco_laranja: totalRiscoLaranja,
    total_risco_amarelo: totalRiscoAmarelo,
    total_risco_verde: totalRiscoVerde,
    total_risco_azul: totalRiscoAzul,
    especialidadeData: especialidadeData,
  };
};

export default GetHospitalData;
